import React, { useState } from 'react'
import styles from './index.module.scss'

const PaymentChoice = ({ onQrPayment, onWaiterPayment, onCancel, totalPrice }) => {
    const [loading, setLoading] = useState(false)

    const handleQrPayment = async () => {
        if (loading) return
        setLoading(true)
        try {
            await onQrPayment()
        } finally {
            setLoading(false)
        }
    }

    const handleWaiterPayment = async () => {
        if (loading) return
        setLoading(true)
        try {
            await onWaiterPayment()
        } finally {
            setLoading(false)
        }
    }

    const handleCancel = async () => {
        if (loading) return
        setLoading(true)
        try {
            await onCancel()
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.popup}>
                <div className={styles.title}>Выберите способ оплаты</div>
                <div className={styles.price}>Сумма: {totalPrice} руб.</div>

                <div className={styles.buttons}>
                    <div
                        className={`${styles.button} ${loading ? styles.disabled : ''}`}
                        onClick={handleQrPayment}
                    >
                        <div className={styles.buttonIcon}>{loading ? '⏳' : '📱'}</div>
                        <div className={styles.buttonText}>Оплатить по QR</div>
                        <div className={styles.buttonDesc}>Отсканируйте QR-код в приложении банка</div>
                    </div>

                    <div
                        className={`${styles.button} ${loading ? styles.disabled : ''}`}
                        onClick={handleWaiterPayment}
                    >
                        <div className={styles.buttonIcon}>{loading ? '⏳' : ''}</div>
                        <div className={styles.buttonText}>Оплата после приема пищи</div>
                        <div className={styles.buttonDesc}>К вам подойдёт официант для оплаты</div>
                    </div>
                </div>

                <div
                    className={`${styles.cancel} ${loading ? styles.disabled : ''}`}
                    onClick={handleCancel}
                >
                    {loading ? 'загрузка...' : 'отменить заказ'}
                </div>
            </div>
        </div>
    )
}

export default PaymentChoice
